(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pd-pdp-meta"] && !Shopify.designMode) return;
  try {
    // Compute live date range from business days. Skips weekends; locale-aware format.
  (function () {
    var el = document.querySelector('[data-pd-ship-range]');
    if (!el) return;
    var min = parseInt(el.getAttribute('data-min'), 10);
    var max = parseInt(el.getAttribute('data-max'), 10);
    if (isNaN(min) || isNaN(max)) return;
    function addBusinessDays(from, days) {
      var d = new Date(from.getTime());
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var day = d.getDay();
        if (day !== 0 && day !== 6) added++;
      }
      return d;
    }
    var now = new Date();
    var a = addBusinessDays(now, min);
    var b = addBusinessDays(now, max);
    var sameYear = a.getFullYear() === b.getFullYear();
    var includeYear = a.getFullYear() !== now.getFullYear() || b.getFullYear() !== now.getFullYear();
    var opts = { month: 'short', day: 'numeric' };
    if (includeYear) opts.year = 'numeric';
    var locale = document.documentElement.lang || 'en';
    var out = el.querySelector('[data-pd-ship-dates]');
    if (out) out.textContent = a.toLocaleDateString(locale, opts) + ' – ' + b.toLocaleDateString(locale, opts);
  })();
  } catch(e) { console.error(e); }
})();

})();
